import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import WorkoutApi from "../Api";
import WorkoutCard from "./WorkoutCard";
import "../navbar.css";

const Workouts = () => {
  let newUser = JSON.parse(localStorage.getItem("user"));

  const [workouts, setWorkouts] = useState(null);
  useEffect(() => {
    WorkoutApi.getWorkouts(newUser.id).then((res) => {
      setWorkouts(res);
    });
  }, []);

  return (
    <>
      <br></br>
      <h1 className="bebas-neue">Workouts</h1>
      <h6 className="bebas-neue">Here you can design, edit, add, and delete</h6>
      <a href={`/workouts/create`}>
        <Button className="buttonspace" color="primary">
          Create a Workout
        </Button>
      </a>
      <p></p>
      <div className="flex-group">
        {workouts
          ? workouts.map((w) => (
              <WorkoutCard
                key={w.id}
                id={w.id}
                user_id={newUser.id}
                name={w.name}
                description={w.description}
              />
            ))
          : "Loading..."}
        <a href="workouts/"></a>
      </div>
    </>
  );
};

export default Workouts;
